import m from 'mithril'
import minimap from './images/mapmini.png'
import LogBookContainer from './LogBookContainer'

class LogBook {
  view(vnode) {
    return (
      <div className="log-book">
        <LogBookContainer {...vnode.attrs} />
        <img className="log-book-minimap" src={minimap} onclick={() => {
              vnode.attrs.toggleLogBook(2);
            }} />
      </div>
    )
  }
}

export default LogBook
